<template>
  <div class="resetPassword">
    <!-- <div class="back" @click="$router.go(-1)">
      <van-icon name="arrow-left" />
    </div> -->
    <div>
      <!-- <div class="p1">
            <img src="./../../assets/img/logo.png" alt="">
            <p>欢迎来到农港城！</p>
      </div>-->
      <div class="p2">
        <div class="p2_phone">
          <input type="number" placeholder="请输入手机号" v-model="subData.mobile" maxlength="11" />
          <van-icon name="cross" v-show="subData.mobile" @click="subData.mobile=''" />
        </div>
        <div class="p2_code">
          <input type="number" placeholder="请输入验证码" v-model="subData.code" maxlength="4" />
          <button class="sendCode" :disabled="isSend" @click="sendCode">{{sendTxt}}</button>
        </div>
        <div class="p2_password">
          <input type="password" placeholder="请输入6-18位数字或英文密码" v-model="subData.password" />
        </div>
        <div class="p2_password">
          <input type="password" placeholder="请再次输入6-18位数字或英文密码" v-model="subData.password_repetition" />
        </div>
      </div>
      <div class="p4">
        <div @click="subDataFun">重置密码</div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile, isPassword0 ,isCode4} from "@/utils/validate";
import { sendCode, resetPassword } from "@/api/login";
import { setToken } from "@/utils/auth";
import Cookies from "@/utils/Cookies";
var t;
export default {
  name: "resetPassword",
  data() {
    return {
      // 要提交的数据
      subData: {
        mobile: "",
        group:'h5',
        code: "",
        password: "",
        password_repetition: ""
      },

      isSend: false,
      sendTxt: "发送验证码"
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 发送验证码
    sendCode() {
      if (isMobile(this.subData.mobile)) {
        this.isSend = true;
        this.sendTxt = "发送中";
        sendCode({mobile:this.subData.mobile,usage:'up-pwd'})
          .then(res => {
            if (res.code == 200) {
              this.$toast("验证码发送成功，请注意查收");
              var time = 60;
              var that = this;
              t = setInterval(function() {
                if (time > 0) {
                  that.isSend = true;
                  that.sendTxt = time + "s";
                  time--;
                } else {
                  that.isSend = false;
                  that.sendTxt = "发送验证码";
                  clearInterval(t);
                }
              }, 1000);
            }
          })
          .catch(res => {
            this.isSend = false;
            this.sendTxt = "发送验证码";
          });
      } else {
        this.$notify({ type: "warning", message: "请输入正确的手机号！" });
      }
    },

    // 提交数据
    subDataFun() {
      if (!isMobile(this.subData.mobile)) {
        this.$notify({ type: "warning", message: "请输入正确的手机号！" });
      } else if (!isCode4(this.subData.code)) {
        this.$notify({ type: "warning", message: "请输入正确的验证码！" });
      } else if (!isPassword0(this.subData.password)) {
        this.$notify({
          type: "warning",
          message: "请输入6-18位数字或英文密码！"
        });
      } else if (!isPassword0(this.subData.password_repetition)) {
        this.$notify({
          type: "warning",
          message: "请再次输入6-18位数字或英文密码！"
        });
      } else if (this.subData.password + "" != this.subData.password_repetition + "") {
        this.$notify({ type: "warning", message: "两次输入的密码不一致！" });
      } else {
        resetPassword(this.subData).then(res => {
          if (res.code == 200) {
            clearInterval(t);
            this.$toast.loading("密码重置成功！正在登录...");
            this.isSend = false;
            this.sendTxt = "发送验证码";
            var data = {
              username: this.subData.mobile,
              password: this.subData.password,
              group: this.subData.group,
            }
            Cookies.remove("account");
            setToken(res.data.access_token);
            Cookies.set("userInfo",JSON.stringify(res.data.user))
            setTimeout(()=>{
              this.$toast.success("登录成功");
              this.$router.push("/");
            },1000)
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.resetPassword {
  width: 100%;
  height: calc(100vh - 0.88rem);
  background-color: #fff;
  box-sizing: border-box;
  padding: 0 0.7rem;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  text-align: left;
  .back {
    font-size: 0.38rem;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 60;
    width: 0.8rem;
    height: 0.88rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .p1 {
    width: 100%;
    text-align: left;
    img {
      width: 1.34rem;
      height: 1.35rem;
      padding-bottom: 0.1rem;
      margin-bottom: 0.2rem;
    }
    p {
      font-size: 0.28rem;
      color: #999;
    }
  }
  .p2 {
    margin-top: 1rem;
    position: relative;
    & > div {
      padding-top: 0.6rem;
      line-height: 0.68rem;
      border-bottom: 0.01rem solid #cccccc;
      display: flex;
      justify-content: space-between;
      align-items: center;
      input {
        width: 5rem;
        background-color: transparent;
        outline: none;
        border: none;
        font-size: 0.3rem;
        color: #333;
        &::placeholder {
          color: #cccccc;
        }
      }
      &:nth-child(2) {
        input {
          width: 4.3rem;
        }
      }
    }
    .sendCode {
      width: 1.8rem;
      text-align: right;
      border: none;
      background-color: transparent;
      font-size: 0.3rem;
      color: #31b158;
      &[disabled] {
        color: #999;
      }
    }
  }

  .p3 {
    margin: 0.3rem auto 0;
    display: flex;
    justify-content: space-between;
    color: #999999;
    .forget {
      color: #999999;
    }
    .van-checkbox__label > span {
      color: #999999 !important;
    }
  }
  .p4 {
    padding-top: 0.5rem;
    div {
      width: 6.1rem;
      box-sizing: border-box;
      height: 0.88rem;
      border-radius: 0.44rem;
      font-size: 0.38rem;
      line-height: 0.88rem;
      text-align: center;
      color: #999;
      font-weight: 500;
      margin-top: 0.4rem;
      border: 0.01rem solid #ccc;
      &:nth-child(1) {
        // background-color: #31b158;
        background:linear-gradient(-90deg,#25A94D,#3FBE66);
        box-shadow: 0px 0.05rem 0.06rem 0px rgba(49,177,88,0.15);
        border: none;
        color: #fff;
      }
    }
  }
}
</style>